module.exports = __webpack_public_path__ + "img/public_resources_play_continue_white.234866d0.svg";